import { EDrawingActionType, ERulerActionType, TMapActions } from '../../actions';

export const defaultState = false;

export function isRulerEnabledReducer(state: boolean = defaultState, action: TMapActions): boolean {
  switch (action.type) {
    case ERulerActionType.RulerEnabled:
      return true;
    case ERulerActionType.RulerDisabled:
    case EDrawingActionType.DrawingStarted:
      return false;
    default:
      return state;
  }
}
